<script>
const sidebarMenu = [
  { path: "/", icon: "fa fa-th", title: "Home" },
  {
    path: "/fm",
    icon: "fa fa-chart-pie",
    title: "Membership functions",
    children: [
      { path: "/fm/triangular", title: "Triangular" },
      { path: "/fm/trapezoidal", title: "Trapezoidal" },
      { path: "/fm/normal", title: "Normal" },
      { path: "/fm/sharpgamma", title: "Sharp Gamma" },
      { path: "/fm/cauchy", title: "Cauchy" }
    ]
  },
  {
    path: "/datasets",
    icon: "fa fa-table",
    title: "Data Sets",
    children: [{ path: "/datasets/iris", title: "Iris" }]
  },
  {
    path: "/vizualization",
    icon: "fa fa-chart-area",
    title: "Vizualization",
    children: [
      { path: "/vizualization/radviz", title: "Radviz" },
     // { path: "/vizualization/radviz2", title: "Radviz2" }
    ]
  },
  {
    path: "/demo",
    icon: "fa fa-gift",
    title: "Demo",
    children: [
      { path: "/demo/test", title: "Testovacia" },
      { path: "/demo/d3", title: "Chart d3" },
      { path: "/demo/chartjs", title: "Chart js" },
      { path: "/demo/inputy", title: "Inputy" }
    ]
  }
];

export default sidebarMenu;
</script>
